import React from "react";
import PropTypes from "prop-types";
import classes from "./styles.module.scss";
import subscribe from "venuescanner-js/react/helpers/subscribe";
import SrpContainer from "../../containers/SrpContainer";

const Summary = ({ totalResults, numResults }) => (
  <p
    className={classes.FoundSpaces}
    tooltip={`${totalResults} space${totalResults === 1 ? "" : "s"} found`}
  >
    <span className={classes.FoundSpaces__count}>{numResults}</span> of{" "}
    <span>{totalResults} venues</span>
  </p>
);

Summary.propTypes = {
  totalResults: PropTypes.number.isRequired,
  numResults: PropTypes.number.isRequired,
};

export default subscribe({ SrpContainer })(
  ({
    srpContainer: {
      state: { data },
      numberOfResults,
    },
  }) => <Summary totalResults={data.all} numResults={numberOfResults} />
);
